import { ACTION } from '../constants';
import getOpenUrlHandler from './openUrl';
import getSwitchToGameHandler from './switchToGame';
import getLaunchCashierHandler from './launchCashier';

export const getButtonSpecificAction = (
    { action, openUrls, gameCode, promoCode, ...props }
) => {
    switch (action) {
        case ACTION.OPEN_URLS: {
            return getOpenUrlHandler(openUrls);
        }

        case ACTION.SWITCH_TO_GAME: {
            return getSwitchToGameHandler({ gameCode, ...props });
        }

        case ACTION.LAUNCH_CASHIER: {
            return getLaunchCashierHandler({ promoCode, ...props });
        }

        default:
            return {};
    }
};
